import React, { FC } from 'react';
import { Image as AntdImage, ImageProps } from 'antd';

type Props = ImageProps & {
  src: string;
  width?: number;
  className?: string;
  preview?: boolean;
};
export const Image: FC<Props> = (props) => {
  return <AntdImage {...props} />;
};
export default Image;
